module.exports = __webpack_public_path__ + "img/triangle-light.2cbfd35e.png";